import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Conectividad/cambioEstadoMaquinaSeleccion`, method: 'POST', body: list, token: token})
}